import { render, staticRenderFns } from "./mail-history.vue?vue&type=template&id=07d68e30"
import script from "./mail-history.vue?vue&type=script&lang=js"
export * from "./mail-history.vue?vue&type=script&lang=js"
import style0 from "./mail-history.vue?vue&type=style&index=0&id=07d68e30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports